import * as yup from 'yup';

export const ModalRedirectEmployeeSchema = yup.object({
  employeeId: yup.string().required('Обязательное поле'),
  serviceId: yup.string().required('Обязательное поле'),
  comment: yup.string().max(128, 'Превышен лимит символов')
});
